import { ProcessCommandActionSettings } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/ProcessCommandActionSettings';
import { ActionController } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/ActionController';
import { CONTENT_TYPES } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/content/RawContentController';
import { ActionFeatures } from '../ActionFeatures';
import { CommandMethods } from 'types/CommandMethods';
import { UseTunnelOwnerContextName } from '../../../configurations/BuilderConfiguration';
import '../Actions.scss';
export const CloseEditorIfOpenedEvent = 'CloseEditorIfOpened';
export class ProcessCommandActionController extends ActionController {
    static $inject = ['close', 'action', '$onStateChanged', '$timeout', '$translate', '$rootScope', 'SidebarContentService', 'PipelineCodeEditorService', 'PipelineBuilderService', 'UndoRedoService', 'state', 'CurrentApplicationService', 'MESSAGINGHUBDOMAIN', '$scope', 'typeOfAction'];
    constructor(close, action, $onStateChanged, $timeout, $translate, $rootScope, SidebarContentService, PipelineCodeEditorService, PipelineBuilderService, UndoRedoService, state, CurrentApplicationService, MESSAGINGHUBDOMAIN, $scope, typeOfAction) {
        super(close, action, $onStateChanged, UndoRedoService, state, $rootScope, $scope, typeOfAction);
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.SidebarContentService = SidebarContentService;
        this.PipelineCodeEditorService = PipelineCodeEditorService;
        this.PipelineBuilderService = PipelineBuilderService;
        this.UndoRedoService = UndoRedoService;
        this.state = state;
        this.CurrentApplicationService = CurrentApplicationService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.commandMethods = [];
        this.isEditorOpened = false;
        this.validResource = true;
        this.applicationIdentityVariable = '{{application.identity}}';
        this.selectMethodChanged = ({ detail: { value } }) => {
            this.action.settings.method = value;
            this.changeMethod();
        };
        this.mimeTypeChanged = ({ detail: { value } }) => {
            this.action.settings.type = value;
            this.save();
        };
        this.toggleIgnoreOwnerContext = this.toggleIgnoreOwnerContext.bind(this);
        this.init();
    }
    async init() {
        this.$scope.$watch('$ctrl.action.settings.variable', (oldValue, newValue) => {
            this.$timeout(this.checkVariable.bind(this));
        });
        this.isActionConditionEnabled = await ActionFeatures.isActionConditionEnabled();
        this.application = await this.CurrentApplicationService.fetchApplicationByStateParams();
        this.insertCommandMethods();
        this.checkTunnelOwnerContext();
        this.addNewContentType = {
            text: this.$translate.instant('builder-tabs-actions.processCommand.addType'),
        };
        this.contentTypes = CONTENT_TYPES.map((type) => ({
            label: type,
            value: type,
        }));
        this.$timeout(() => {
            this.processCommandForm.uri && this.processCommandForm.uri.$setDirty();
            this.processCommandForm.to && this.processCommandForm.to.$setDirty();
            this.processCommandForm.type && this.processCommandForm.type.$setDirty();
            this.changeMethod();
            this.$scope.$watch('$ctrl.action.settings.uri', (oldValue, newValue) => {
                this.checkURI();
            });
        });
        if (!this.action.settings.method) {
            this.action.settings.method = CommandMethods.get;
            this.save();
        }
        if (this.action.settings.method !== CommandMethods.get) {
            if (!this.action.settings.type) {
                this.action.settings.type = 'application/json';
            }
            if (!this.action.settings.resource) {
                this.action.settings.resource = this.setResource();
            }
        }
        if (!this.action.conditions) {
            this.action.conditions = [];
        }
    }
    async checkTunnelOwnerContext() {
        const configuration = await this.PipelineBuilderService.getFlowConfiguration();
        this.isTunnelOwnerContextEnabled = configuration[UseTunnelOwnerContextName] == 'true';
    }
    insertCommandMethods() {
        Object.keys(CommandMethods).forEach(key => this.commandMethods.push({ value: key, label: key }));
    }
    startEditing() {
        const input = document.getElementById('send-command-title');
        if (input) {
            input.focus();
        }
    }
    onBlur() {
        this.isEditing = false;
        if (this.action.$title.length === 0) {
            this.action.$title = this.$translate.instant('builder-tabs-actions.processCommand.title');
            this.save();
        }
    }
    onToChange() {
        if (this.action.settings?.to.endsWith(`@desk.${this.MESSAGINGHUBDOMAIN}`)) {
            this.action.settings.from = this.applicationIdentityVariable;
        }
        else {
            this.action.settings.from = undefined;
        }
        this.save();
    }
    toggleIgnoreOwnerContext(event) {
        if (event.detail.checked) {
            this.action.settings.from = this.applicationIdentityVariable;
        }
        else {
            this.action.settings.from = undefined;
        }
        this.save();
    }
    compareTexts(a, b) {
        try {
            const nameA = a.label ? a.label.toLowerCase() : '';
            const nameB = b.label ? b.label.toLowerCase() : '';
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        }
        catch (err) {
            console.error(err);
            return 0;
        }
    }
    changeMethod() {
        switch (this.action.settings.method) {
            case CommandMethods.set:
            case CommandMethods.merge:
            case CommandMethods.observe:
                this.hasResource = true;
                this.action.settings.resource = this.action.settings.resource
                    ? this.action.settings.resource
                    : this.setResource();
                if (!this.action.settings.type) {
                    this.action.settings.type = '';
                }
                break;
            default:
                this.hasResource = false;
                this.action.settings.type = '';
                this.action.settings.resource = '';
                this.isEditorOpened && this.closeEditor();
                const { type, resource, ...rest } = this.action.settings;
                this.action.settings = { ...rest };
                break;
        }
        this.save();
    }
    checkURI() {
        if (!this.action.settings.uri ||
            !(this.action.settings.uri.startsWith('/') || this.action.settings.uri.startsWith('lime://'))) {
            this.processCommandForm.uri.$invalid = true;
            this.processCommandForm.uri.$valid = false;
        }
        this.save();
    }
    checkVariable() {
        const setVariableValidity = (isValid) => {
            this.processCommandForm.variable.$invalid = !isValid;
            this.processCommandForm.variable.$valid = isValid;
        };
        try {
            if (this.action.settings.variable &&
                (!this.action.settings.variable.match(/^([a-zA-Z0-9]+)$/))) {
                setVariableValidity(false);
                this.processCommandForm.variable.$setDirty();
            }
        }
        catch (e) {
            console.error(e);
            setVariableValidity(false);
            this.processCommandForm.variable.$setDirty();
        }
        this.save();
    }
    setResource() {
        return `{
    "key": "value"
}
        `;
    }
    closeEditor() {
        this.SidebarContentService.cleanAndClose(false, this.sidebarEditor);
        this.isEditorOpened = false;
        this.sidebarEditor = undefined;
        !this.action.settings.resource && this.setResource();
    }
    toggleCodeEditor() {
        if (this.isEditorOpened) {
            this.closeEditor();
        }
        else {
            this.openCodeEditor();
            this.isEditorOpened = true;
        }
    }
    async openCodeEditor() {
        this.sidebarEditor = await this.PipelineCodeEditorService.openCodeEditor({
            code: this.action.settings.resource,
            language: 'json',
            editorWasCreated: this.editorWasCreated.bind(this),
            SidebarContentService: this.SidebarContentService,
            onCodeEditorChange: ({ code }) => {
                try {
                    if (this.action.settings.type && this.action.settings.type.endsWith('json')) {
                        this.action.settings.resource = JSON.parse(code);
                    }
                    else {
                        this.action.settings.resource = code;
                    }
                    this.validResource = true;
                }
                catch (e) {
                    console.error(e);
                    this.validResource = false;
                }
            },
            onSaveSource: () => {
                this.save();
            },
        });
        const deregisterCloseEditorEvent = this.$rootScope.$on(CloseEditorIfOpenedEvent, () => {
            this.SidebarContentService.cleanAndClose(false, this.sidebarEditor);
        });
        await this.sidebarEditor.closeDeferred.promise; // when code editor close
        deregisterCloseEditorEvent();
        this.isEditorOpened = false;
    }
    editorWasCreated({ editor }) {
        this.isMonacoLoading = false;
        setTimeout(() => {
            // Time to sidebar animation
            editor.layout();
        }, 500);
    }
    create() {
        return new ProcessCommandActionSettings();
    }
}
ProcessCommandActionController.$inject = ['close', 'action', '$onStateChanged', '$timeout', '$translate', '$rootScope', 'SidebarContentService', 'PipelineCodeEditorService', 'PipelineBuilderService', 'UndoRedoService', 'state', 'CurrentApplicationService', 'MESSAGINGHUBDOMAIN', '$scope', 'typeOfAction'];
